/** Same name/strength/supplement presentation in the Visit Report and Clinical tab. */
export function medicationDisplay(row) {
    const isSupplement = row.isSupplement === true || / - Supplement\s*$/.test(row.name);
    const cleanName = isSupplement ? row.name.replace(/ - Supplement\s*$/, "") : row.name;
    const strength = String(row.strength ?? row.dosage ?? "").trim();
    const name = !strength || cleanName.toLowerCase().includes(strength.toLowerCase())
        ? cleanName
        : `${cleanName} ${strength}`;
    return { name, route: row.route, isSupplement };
}
//# sourceMappingURL=clinical-profile.js.map